import React from "react";
import { motion } from "framer-motion";

const SearchBar = ({ handle, setHandle, searchHandler }) => {
  return (
    <div className="m-auto flex">
      <label
        className="block text-gray-700 text-md font-bold m-4 ml-2"
        htmlFor="Username:"
      >
        Username:
      </label>
      <div className="flex items-center">
        <input
          className="py-1 px-4"
          type="text"
          placeholder=""
          value={handle}
          onChange={(e) => setHandle(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              searchHandler();
            }
          }}
        />
        <motion.button
          className="bg-red-500 px-2 rounded-sm text-2xl"
          onClick={searchHandler}
        >
          <i className="ri-search-line"></i>
        </motion.button>
      </div>
    </div>
  );
};

export default SearchBar;
